var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3777_13291)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#004988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.75 42.3124C73.7503 45.5212 72.8009 48.6584 71.0214 51.3286C69.2418 53.9988 66.7118 56.0826 63.75 57.3174V57.3124C63.75 51.6765 61.5112 46.2715 57.526 42.2863C53.5409 38.3012 48.1359 36.0624 42.5 36.0624H42.495C43.942 32.5967 46.5445 29.739 49.86 27.975C53.1756 26.211 56.9997 25.6495 60.6824 26.3859C64.3651 27.1223 67.6792 29.1112 70.0614 32.0146C72.4436 34.918 73.747 38.5567 73.75 42.3124ZM37.5 27.3124C34.8478 27.3124 32.3043 28.3659 30.4289 30.2413C28.5536 32.1167 27.5 34.6602 27.5 37.3124V41.0624H32.5V37.3124C32.5 35.9863 33.0268 34.7145 33.9645 33.7768C34.9021 32.8391 36.1739 32.3124 37.5 32.3124H41.25V27.3124H37.5ZM67.5 58.5624V62.3124C67.5 63.6384 66.9732 64.9102 66.0355 65.8479C65.0979 66.7856 63.8261 67.3124 62.5 67.3124H58.75V72.3124H62.5C65.1522 72.3124 67.6957 71.2588 69.5711 69.3834C71.4464 67.5081 72.5 64.9645 72.5 62.3124V58.5624H67.5ZM42.5 73.5624C46.8098 73.5624 50.943 71.8503 53.9905 68.8028C57.038 65.7554 58.75 61.6221 58.75 57.3124C58.75 53.0026 57.038 48.8693 53.9905 45.8219C50.943 42.7744 46.8098 41.0624 42.5 41.0624C38.1902 41.0624 34.057 42.7744 31.0095 45.8219C27.962 48.8693 26.25 53.0026 26.25 57.3124C26.25 61.6221 27.962 65.7554 31.0095 68.8028C34.057 71.8503 38.1902 73.5624 42.5 73.5624ZM42.5 51.0624L48.75 57.3124L42.5 63.5624L36.25 57.3124L42.5 51.0624Z",
    fill: "#004988"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3777_13291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapAssets);
export default __webpack_public_path__ + "static/media/swapAssets.a1a8a26eadc70e6835790cd83f21dcc2.svg";
export { ForwardRef as ReactComponent };